export default function getAge(birthdate, deceasedDate) {
  if (!birthdate) return "";
  let calculatedAge = "";
  let yearString = "";
  let monthString = "";
  let dayString = "";
  let age = CalculateAge(birthdate, deceasedDate);
  if (age.years > 1) yearString = "y";
  else yearString = "y";
  if (age.months > 1) monthString = "m";
  else monthString = "m";
  if (age.days > 1) dayString = "d";
  else dayString = "d";
  if (age.years > 0 && age.months > 0 && age.days > 0)
    calculatedAge =
      age.years +
      yearString +
      " " +
      age.months +
      monthString +
      " " +
      age.days +
      dayString;
  else if (age.years === 0 && age.months === 0 && age.days > 0)
    calculatedAge = age.days + dayString;
  else if (age.years > 0 && age.months === 0 && age.days === 0)
    calculatedAge = age.years + yearString;
  else if (age.years > 0 && age.months > 0 && age.days === 0)
    calculatedAge = age.years + yearString + " " + age.months + monthString;
  else if (age.years === 0 && age.months > 0 && age.days > 0)
    calculatedAge = age.months + monthString + " " + age.days + dayString;
  else if (age.years > 0 && age.months === 0 && age.days > 0)
    calculatedAge = age.years + yearString + " " + age.days + dayString;
  else if (age.years === 0 && age.months > 0 && age.days === 0)
    calculatedAge = age.months + monthString;
  return calculatedAge;
}

function CalculateAge(birthdate, deceasedDate) {
  let now = new Date();
  let monthAge;
  let dateAge;
  const dob = new Date(birthdate);

  if (deceasedDate !== undefined && deceasedDate < now) {
    now = deceasedDate;
  }

  const currentdate = now.getDate();
  const currentmonth = now.getMonth();
  const currentyear = now.getFullYear();
  const dobdate = dob.getDate();
  const dobmonth = dob.getMonth();
  const dobyear = dob.getFullYear();
  let yearAge = currentyear - dobyear;
  if (currentmonth >= dobmonth) {
    monthAge = currentmonth - dobmonth;
  } else {
    yearAge--;
    monthAge = 12 + currentmonth - dobmonth;
  }
  if (currentdate >= dobdate) {
    dateAge = currentdate - dobdate;
  } else {
    monthAge--;
    dateAge = 31 + currentdate - dobdate;
  }
  if (monthAge < 0) {
    monthAge = 11;
    yearAge--;
  }
  const age = {
    years: yearAge,
    months: monthAge,
    days: dateAge,
  };
  return age;
}
